<template>
  <fragment>
    <g id="Y-Shirts_B-1-1-1_A" v-if="data.value === 'type-8'">
      <path
        d="M140.26,253.92c0-3.88,4.57-8.8,19.29-8.8,15.7,0,19.29,5.35,19.29,8.8,0,4.4-8.52,17.84-19.17,17.84s-19.4-13.44-19.4-17.84Z"
        fill="#b5b5b5"
      />
    </g>
    <g id="Y-Shirts_B-1-1-2_B" v-if="data.value === 'type-11'">
      <path
        d="M140.26,253.92c0-3.88,4.57-8.8,19.29-8.8,15.7,0,19.29,5.35,19.29,8.8,0,4.4-8.52,17.84-19.17,17.84s-19.4-13.44-19.4-17.84Z"
        fill="#88b9c9"
      />
    </g>
    <g id="Y-Shirts_B-1-1-3_C" v-if="data.value === 'type-9'">
      <path
        d="M140.26,253.92c0-3.88,4.57-8.8,19.29-8.8,15.7,0,19.29,5.35,19.29,8.8,0,4.4-8.52,17.84-19.17,17.84s-19.4-13.44-19.4-17.84Z"
        fill="#131111"
      />
    </g>
    <g id="Y-Shirts_B-1-1-4_D" v-if="data.value === 'type-10'">
      <path
        d="M140.26,253.92c0-3.88,4.57-8.8,19.29-8.8,15.7,0,19.29,5.35,19.29,8.8,0,4.4-8.52,17.84-19.17,17.84s-19.4-13.44-19.4-17.84Z"
        fill="#162c4c"
      />
    </g>
    <g id="Y-Shirts_B-1-1-5_E" v-if="data.value === 'type-12'">
      <path
        d="M140.26,253.92c0-3.88,4.57-8.8,19.29-8.8,15.7,0,19.29,5.35,19.29,8.8,0,4.4-8.52,17.84-19.17,17.84s-19.4-13.44-19.4-17.84Z"
        fill="#f495a3"
      />
    </g>
    <g id="Y-Shirts_B-1-1-6_F" v-if="data.value === 'type-13'">
      <path
        d="M140.26,253.92c0-3.88,4.57-8.8,19.29-8.8,15.7,0,19.29,5.35,19.29,8.8,0,4.4-8.52,17.84-19.17,17.84s-19.4-13.44-19.4-17.84Z"
        fill="#334072"
      />
    </g>
    <g id="Y-Shirts_B-1-1-7_G" v-if="data.value === 'type-14'">
      <path
        d="M140.26,253.92c0-3.88,4.57-8.8,19.29-8.8,15.7,0,19.29,5.35,19.29,8.8,0,4.4-8.52,17.84-19.17,17.84s-19.4-13.44-19.4-17.84Z"
        fill="#292929"
      />
    </g>
  </fragment>
</template>

<script>
export default {
  name: 'avatarShirtsA',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
